"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useCarouselValues_unstable", {
    enumerable: true,
    get: function() {
        return useCarouselValues_unstable;
    }
});
const _shim = require("use-sync-external-store/shim");
const _CarouselContext = require("./CarouselContext");
function useCarouselValues_unstable(getSnapshot) {
    const store = (0, _CarouselContext.useCarouselContext_unstable)((c)=>c.store);
    return (0, _shim.useSyncExternalStore)(store.subscribe, ()=>getSnapshot(store.getSnapshot()));
}
